export enum AppExceptionCode {
  APP_NOT_FOUND,
  APP_NOT_REGISTERED,
  UNKNOWN,
}

export const AppExceptionMessage = {
  [AppExceptionCode.APP_NOT_FOUND]: 'App not found',
  [AppExceptionCode.APP_NOT_REGISTERED]: 'App not registered',
  [AppExceptionCode.UNKNOWN]: 'Unknown error',
};

export class AppException extends Error {
  public code: AppExceptionCode;

  constructor(public type: keyof typeof AppExceptionCode = 'UNKNOWN') {
    super(AppExceptionMessage[AppExceptionCode[type]]);

    this.name = type;
    this.code = AppExceptionCode[type];

    const prototypeChain = new.target.prototype;

    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(this, prototypeChain);
    }
  }
}

export const isAppException = (error: unknown): error is AppException => {
  return error instanceof AppException;
};
